import * as swcHelpers from '@swc/helpers';
import { takeLatest, select, put } from 'redux-saga/effects';
import { Actions, Selectors, State, Types } from '@grandvisionhq/auth';
import { statusSuccess } from '@grandvisionhq/state';
import { changeFormValue } from '../actions.js';
import { profileEditSuccess, profileEditError } from '../data-layer/actions.js';
import { getFormData, getForms } from './selectors.js';
import { SUBMIT_USER_FORM } from './actions.js';

function* submitUserForm(action) {
    const formName = action.payload;
    const auth = yield select(Selectors.getAuth);
    const userData = yield select(Selectors.getUserData);
    const formData = yield select(getFormData);
    if (!State.isLoggedIn(auth)) {
        throw new Error(`Can't fetch user data when not logged in`);
    }
    if (userData && statusSuccess(userData)) {
        yield put(Actions.UserDataActions.updateUserData({
            formName,
            formData: formData[formName]
        }));
    }
}
function* updateForm(action) {
    const formData = yield select(getForms) || {};
    const formNames = Object.keys(Types.FormName);
    const serverData = action.type === Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS ? action.payload.server : action.payload;
    const newFormsState = formNames.reduce((formAcc, formName)=>{
        const form = formData[formName];
        const clientForm = form && form.state || {
            formValid: false,
            formName,
            formState: {}
        };
        const serverForm = serverData[formName];
        if (!serverForm) {
            return formAcc;
        }
        const clientFieldNames = Object.keys(clientForm.formState);
        const serverFieldNames = Object.keys(serverForm);
        const combinedFieldNames = Array.from(new Set([
            ...clientFieldNames,
            ...serverFieldNames
        ]));
        const newFieldValues = combinedFieldNames.reduce((fieldAcc, fieldName)=>{
            const clientFieldState = clientForm.formState[fieldName] || {
                name: fieldName,
                value: ''
            };
            const serverValue = serverForm[fieldName];
            const value = serverValue ? serverValue.toString() : clientFieldState.value;
            // Don't store the fields initial state whenever there is no valid useful initial value e.g. an empty string
            return swcHelpers.objectSpread({}, fieldAcc, value && {
                [fieldName]: swcHelpers.objectSpread({}, clientFieldState, {
                    value
                })
            });
        }, {});
        return swcHelpers.objectSpread({}, formAcc, {
            [formName]: swcHelpers.objectSpread({}, clientForm, {
                formState: newFieldValues
            })
        });
    }, {});
    if (newFormsState.personalDetails) {
        yield put(changeFormValue({
            form: newFormsState.personalDetails
        }));
    }
    if (newFormsState.billingAddress) {
        yield put(changeFormValue({
            form: newFormsState.billingAddress
        }));
    }
    if (newFormsState.preferredStore) {
        yield put(changeFormValue({
            form: newFormsState.preferredStore
        }));
    }
}
function* userFormSuccess() {
    yield put(profileEditSuccess());
}
function* userFormFailed(action) {
    const { error  } = action.payload;
    yield put(profileEditError(error));
}
var profileSagas = [
    takeLatest(SUBMIT_USER_FORM, submitUserForm),
    takeLatest(Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS, userFormSuccess),
    takeLatest(Actions.UserDataActions.UPDATE_USER_DATA_FAILED, userFormFailed),
    takeLatest([
        Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS,
        Actions.UserDataActions.FETCH_USER_DATA_SUCCESS, 
    ], updateForm), 
];

export { profileSagas as default, submitUserForm, updateForm, userFormFailed, userFormSuccess };
//# sourceMappingURL=sagas.js.map
